import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { urls } from "../../endPoints";
import { doPost } from "../../../config/fetchWrapper";

export const UpdateCustomPlaybookQuestionsAction = createAsyncThunk(
    "updateCustomPlaybookQuestions",
    async (arg, { rejectWithValue }) => {
        try {
            const responseData = await doPost(urls?.updateCustomPlaybookQuestions, arg);
            return responseData;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const updateCustomPlaybookQuestionsSlice = createSlice({
    name: "updateCustomPlaybookQuestions",
    initialState: {
        isLoading: false,
        success: false,
        error: null,
        data: false,
    },
    reducers: {
        updateCustomPlaybookQuestionsReset: () => {
            return {
                isLoading: false,
                success: false,
                error: null,
                data: false,
            };
        },
    },
    extraReducers: {
        [UpdateCustomPlaybookQuestionsAction.pending]: (state) => {
            state.isLoading = true;
            state.success = false;
            state.error = null;
        },
        [UpdateCustomPlaybookQuestionsAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.success = true;
            state.error = null;
            state.data = payload;
        },
        [UpdateCustomPlaybookQuestionsAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.success = false;
            state.error = payload;
        },
    },
});

export const { updateCustomPlaybookQuestionsReset } = updateCustomPlaybookQuestionsSlice.actions;
export default updateCustomPlaybookQuestionsSlice.reducer;
